import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import _ from 'lodash';
import { isPromise } from '@jutro/platform';
import { log } from '@jutro/logger';
import { showAlert } from './alertHelper';
import { navigateTo } from './navigationHelper';
import { getErrorCategory } from './errorCategorizer';
export function invokeAction(name, props, context, onSuccess, onFailure) {
  const actionFunction = props.function;
  let actionArgs = props.args;
  if (!actionFunction || _.isString(actionFunction)) {
    log.error("Could not resolve action function: \"".concat(actionFunction || name, "\""));
    return undefined;
  }
  if (actionArgs) {
    actionArgs = _mapInstanceProperty(actionArgs).call(actionArgs, prop => context[prop]);
  }
  let result;
  let resultException;
  try {
    result = actionArgs ? actionFunction(...actionArgs) : actionFunction();
  } catch (ex) {
    result = false;
    resultException = ex;
  }
  return {
    name,
    result,
    resultException,
    progress: props.progress,
    success: props.success,
    failure: props.failure,
    onSuccess,
    onFailure
  };
}
export function actionResultWithPaths(result, successPath, failurePath, progressMsg) {
  const actionObject = {
    name: 'unnamed',
    result
  };
  if (progressMsg !== undefined) {
    actionObject.progress = {
      message: progressMsg
    };
  }
  if (successPath !== undefined) {
    actionObject.success = {
      path: successPath
    };
  }
  if (failurePath !== undefined) {
    actionObject.failure = {
      path: failurePath
    };
  }
  return actionObject;
}
export async function handleAction(actionObject, instance, translator) {
  if (instance) {
    if (!instance.setState || !instance.props || !instance.props.history) {
      log.error('"Instance" provided to AsyncLink.handleAction does not have "setState" or "history" props');
      return;
    }
  }
  const name = actionObject.name,
    result = actionObject.result,
    resultException = actionObject.resultException,
    progress = actionObject.progress,
    success = actionObject.success,
    failure = actionObject.failure,
    onSuccess = actionObject.onSuccess,
    onFailure = actionObject.onFailure;
  const _ref = progress || {},
    message = _ref.message;
  const _ref2 = success || {},
    to = _ref2.path,
    toMessage = _ref2.message;
  const _ref3 = failure || {},
    failTo = _ref3.path,
    failToMessage = _ref3.message;
  const onAlert = showAlert;
  const onNavigate = navigateTo;
  if (!isPromise(result)) {
    if (result !== false) {
      if (onSuccess) {
        onSuccess(name, result);
      }
      if (to && onNavigate) {
        onNavigate(instance, to, result);
      } else if (toMessage && onAlert) {
        onAlert(translator(toMessage));
      }
      return;
    }
    if (resultException !== undefined && resultException !== false) {
      if (onFailure) {
        onFailure(name, resultException);
      }
      if (failTo && onNavigate) {
        onNavigate(instance, failTo, resultException);
      } else if (failToMessage && onAlert) {
        onAlert(translator(failToMessage));
      }
      return;
    }
    return;
  }
  try {
    if (instance) {
      instance.setState({
        loading: true,
        message: translator(message)
      });
    }
    const data = await result;
    if (instance) {
      instance.setState({
        loading: false,
        message: null
      });
    }
    if (data !== false) {
      if (onSuccess) {
        onSuccess(name, data);
      }
      if (to && onNavigate) {
        onNavigate(instance, to, data);
      } else if (toMessage && onAlert) {
        onAlert(translator(toMessage));
      }
    }
  } catch (error) {
    let computedFailTo = failTo;
    if (error instanceof Error) {
      log.error("AsyncLink: ".concat(error));
    }
    if (instance) {
      instance.setState({
        loading: false,
        message: null
      });
    }
    if (error === false) {
      return;
    }
    if (onFailure) {
      onFailure(name, error);
    }
    if (error === false) {
      return;
    }
    let errorData = error;
    const errorCategory = getErrorCategory(error.errorCode || error);
    const knockoutPath = errorCategory.knockoutPath,
      errorProps = _objectWithoutProperties(errorCategory, ["knockoutPath"]);
    if (knockoutPath) {
      computedFailTo = knockoutPath;
    }
    if (!_.isEmpty(errorProps)) {
      errorData = _objectSpread({}, errorProps, {
        error
      });
    }
    if (computedFailTo && onNavigate) {
      onNavigate(instance, computedFailTo, errorData);
    } else if (failToMessage && onAlert) {
      onAlert(translator(failToMessage));
    }
  }
}
export function checkActionIntegrity(events, props, context) {
  if (!events || !props || !context) {
    return;
  }
  _forEachInstanceProperty(events).call(events, evt => {
    const actionProps = props[evt];
    if (actionProps) {
      if (_.isString(actionProps.function)) {
        log.error("Could not resolve action function: \"".concat(actionProps.function, "\". Check return from \"getActionFunctions()\""));
        return;
      }
      if (actionProps.function && actionProps.args) {
        var _context;
        const missing = _reduceInstanceProperty(_context = actionProps.args).call(_context, (list, prop) => {
          if (!Object.prototype.hasOwnProperty.call(context, prop)) {
            list.push(prop);
          }
          return list;
        }, []);
        if (missing.length !== 0) {
          log.error("Could not resolve action function arguments from action context: \"".concat(actionProps.name, "(").concat(missing, ")\". Check return from \"getActionContext()\""));
        }
      }
    }
  });
}